<template>
  <div>
    <form @submit.prevent="save">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Split Products</p>
        </header>
        <section class="modal-card-body">
          <div class="mb-lg">
            <b-message v-if="generalError" type="is-danger" class="is-size-7">
              {{ generalError }}
            </b-message>
            <b-message v-else-if="!canSplitProposal" type="is-danger">It looks like you've selected all products in this
              proposal.
              Please select only the products you want to move — at least one product must remain in the current
              proposal.</b-message>
            <b-message v-else type="is-info" class="is-size-7">
              These products will be moved into a new proposal and removed from this one.
              Are you sure you want to split <b>{{ this.products.length }}</b> {{ (this.products.length == 1) ?
                "product" : "products" }} into a separate proposal?
            </b-message>
          </div>
          <div class="mb-lg">
            <p class="has-text-weight-bold mb-sm">Behavior</p>
            <b-field><b-radio v-model="method" native-value="new">Add products to a <b>new</b>
                proposal</b-radio></b-field>
            <!-- <b-field><b-radio v-model="method" native-value="existing">Add products to an <b>existing</b> proposal</b-radio></b-field> -->
          </div>
          <div v-if="method === 'new'" class="mb-lg">
            <!-- New Proposal Name -->
            <b-field label="New Proposal Name" :type="('name' in errors) ? 'is-danger' : ''"
              :message="('name' in errors) ? errors['name'][0] : ''" expanded>
              <b-input type="text" v-model="name" placeholder="Enter new proposal name..." size="is-medium"></b-input>
            </b-field>
          </div>
        </section>
        <footer class="modal-card-foot space-between">
          <b-button @click="$parent.close()">Close</b-button>
          <b-button type="is-primary" native-type="submit" :loading="saving" :disabled="!canSplitProposal || saving">
            Split Products
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['context']),
    canSplitProposal () {
      if (this.products.length === this.proposal.item_count) {
        return false
      }
      return true
    }
  },
  data () {
    return {
      loadingUsers: true,
      users: [],
      method: 'new',
      name: null,
      proposalOwner: null,
      saving: false,
      errors: {},
      generalError: null
    }
  },
  methods: {
    loadUsers () {
      this.loadingUsers = true
      const endpoint = this.context.route + '/users/'
      const query = {
        params: {
          pagination: 0,
          mini: 1,
          type: 'standard',
          order_by: 'last_name',
          status: 'active,invited'
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.users = response.data.results
        this.loadingUsers = false
      })
    },
    save () {
      this.saving = true
      const endpoint = this.context.route + `/proposals/${this.proposal.id}/split/`
      const body = {
        name: this.name,
        product_ids: this.$utils.map(this.products, 'id')
      }
      this.$http.post(endpoint, body).then(response => {
        this.$buefy.toast.open({ type: 'is-success', message: 'Proposals merged!' })
        this.$emit('products:split')
        this.$parent.close()
      }).catch(() => {
        this.generalError = 'These products cannot be splitted (likely because of the status of the proposal).'
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: {
    proposal: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  }
}
</script>
